var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cgqBox"},[_c('div',{staticClass:"cgqBoxTil"},[_vm._v("\n\t\t\tCBI分光染色·火眼金睛\n\t\t")]),_c('div',{staticClass:"cgqBoxCen"},[_vm._v("\n\t\t\t支持自主研发的CBI分光染色模式，\n\t\t\t可进一步增强黏膜细节的对比度及浅表纤维结构\n\t\t")]),_c('div',{staticClass:"cgqBoxSp"},[_c('img',{attrs:{"src":require("@/assets/product/page6/sp.png")}})])])])
}]

export { render, staticRenderFns }